<script>
import VDescriptionList from '.';

export default {
  name: 'DescriptionListHorizontalCols',

  functional: true,

  render: (h, { children }) => {
    children = children.filter(c => c.tag);
    if (children.length === 0) return;
    // each entry is a combination of headline and element (when using VEntry)
    // if there are less than 4 entries use the DescriptionList
    if (children.length < 4) return h(VDescriptionList, children);

    const output = [];
    for (let i = 0; i < children.length; i += 4) {
      // How to calculate the children is a bit confusing, so here are the definitions (for VEntry, 2 element 'pairs')
      // i = current heading, i+1 = current description
      // i+2 = right element heading, i+3 = right element description
      // i+4= next row left heading, i+5= next row left description
      // i+6=next row right heading, ...

      // default expectation is, that nothing follows. So no line is drawn
      let classFirstColumn = '';
      let classSecondColumn = '';

      if (i + 6 < children.length) {
        // we do have two elements on the following row, therefore we draw both lines
        classFirstColumn = 'line';
        classSecondColumn = 'line';
      } else if (i + 4 < children.length) {
        // element right and below us exists, but nothing next row on the right side
        classFirstColumn = 'line';
        classSecondColumn = 'bottom-line-m';
      } else if (i + 2 < children.length) {
        // just one element on the right side of us
        classFirstColumn = 'bottom-line-m';
        classSecondColumn = '';
      }

      const cols = [h('div', { staticClass: 'col-l-6 col-m-12' }, [h(VDescriptionList, { staticClass: classFirstColumn }, [children[i], children[i + 1]])])];

      if (children[i + 2] !== undefined) {
        cols.push(h('div', { staticClass: 'col-l-6 col-m-12' }, [h(VDescriptionList, { staticClass: classSecondColumn }, [children[i + 2], children[i + 3]])]));
      }

      output.push(h('div', { staticClass: 'row auto-height-container' }, cols));
    }
    return output;
  },
};
</script>
